import { useMutation } from 'react-query';

import { uploadDataStory as mutationFn } from 'api/endPoints/uploadDataStory';

export const useMutationCreateEditStory = () => {
    return useMutation<unknown, QueryError, unknown>((params) => mutationFn(params));
};
